const unstable_IconRadioGroupIcon = {
  TextAlignCenter: "TextAlignCenter",
  TextAlignJustify: "TextAlignJustify",
  TextAlignLeft: "TextAlignLeft",
  TextAlignRight: "TextAlignRight",
  Superscript: "Superscript16",
  Subscript: "Subscript16",
  Code: "Code16"
};
const IconRadioGroupControlType = "makeswift::controls::icon-radio-group";
function unstable_IconRadioGroup(config) {
  return { type: IconRadioGroupControlType, config };
}
export {
  IconRadioGroupControlType,
  unstable_IconRadioGroup,
  unstable_IconRadioGroupIcon
};
//# sourceMappingURL=icon-radio-group.js.map